import {Pipe, PipeTransform} from '@angular/core';
import {Util} from '../models/generico/util';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {

    transform(dataInicio: Date, dataFim: Date) {
        return !dataInicio || !dataFim ? '' : Util.duration(new Date(dataInicio), new Date(dataFim));
    }

}
